import React from 'react'
import Select from 'react-select';
import { showSuccessMsg, showErrorMsg } from '../../util/messagesUtil';
import $ from 'jquery'

export class ModalImportarUsuariosSistema extends React.Component {
    constructor(props) {
        super(props);
        this.state = { empresaReferenciaOrigem: null }
        this.state = { empresaReferenciaDestino: null }
    }

    handleEmpresaOrigemChange(empresaReferenciaOrigem) {
        this.setState({ empresaReferenciaOrigem: empresaReferenciaOrigem })
    }

    handleEmpresaDestinoChange(empresaReferenciaDestino) {
        this.setState({ empresaReferenciaDestino: empresaReferenciaDestino })
    }

    fecharModal() {
        $('#modalImportarUsuarios')
            .modal('hide');
        $('#modalImportarUsuarios')
            .hide();
        $('.modal-backdrop')
            .hide();
    }

    importarUsuarios() {
        if (this.state.empresaReferenciaDestino.value === this.state.empresaReferenciaOrigem.value) {
            showErrorMsg('Não é possível importar usuários para a mesma empresa.')
        } else {
            this.props.importarUsuariosEmpresa(this.state.empresaReferenciaOrigem.value, this.state.empresaReferenciaDestino.value)
                .then(() => {
                    this.props.buscarUsuario()
                    showSuccessMsg('Importação realizada.')
                    this.fecharModal();
                    this.setState({ empresaReferenciaOrigem: null, empresaReferenciaDestino: null });
                })

        }
    }

    render() {
        return (
            <div className="modal fade show" id='modalImportarUsuarios' role='dialog'
                aria-labelledby='modalImportarUsuarios' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Importar usuários de uma empresa para outra empresa</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-8 mb-3">
                                    <span><b>DE:</b></span>
                                    <Select
                                        maxMenuHeight={400}
                                        menuPlacement="auto"
                                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                        placeholder='Selecione a empresa DE onde deseja importar'
                                        options={this.props.empresas.map(elemento => ({
                                            label: elemento.nomeFantasia,
                                            value: elemento.id
                                        }))}
                                        value={this.state.empresaReferenciaOrigem ? ({
                                            label: this.state.empresaReferenciaOrigem.label,
                                            value: this.state.empresaReferenciaOrigem.id
                                        }) : ''}
                                        onChange={value => this.handleEmpresaOrigemChange(value)}
                                    />
                                </div>
                                <div className="col-8 mb-3">
                                    <span><b>PARA:</b></span>
                                    <Select
                                        maxMenuHeight={400}
                                        menuPlacement="auto"
                                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                        placeholder='Selecione a empresa PARA onde deseja importar'
                                        options={this.props.empresas.map(elemento => ({
                                            label: elemento.nomeFantasia,
                                            value: elemento.id
                                        }))}
                                        value={this.state.empresaReferenciaDestino ? ({
                                            label: this.state.empresaReferenciaDestino.label,
                                            value: this.state.empresaReferenciaDestino.id
                                        }) : ''}
                                        onChange={value => this.handleEmpresaDestinoChange(value)}
                                    />
                                </div>
                                <div className="col-3 mt-n3">
                                    <button type='button' onClick={() => this.importarUsuarios()}
                                        disabled={!this.state.empresaReferenciaDestino || !this.state.empresaReferenciaOrigem}
                                        className="btn btn-laranja">
                                        IMPORTAR
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (ModalImportarUsuariosSistema);
